export default "__VITE_ASSET__Bx5pV57w__"